import styled from 'styled-components';

const StyledButton = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  right: ${({ hideThumbnail }) => (hideThumbnail ? 0 : 'inherit')};
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  pointer-events: all;
  opacity: 1;
  z-index: 503;
  transition: opacity 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  background: transparent;
  border: none;

  &:hover {
    cursor: pointer;
  }

  &:before {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: #00a9f7;
    opacity: 0;
  }

  &:after {
    width: 70px;
    height: 70px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: #00a9f7;
    box-shadow: 0 13px 27px -5px rgba(50, 50, 93, 0.25), 0 8px 16px -8px rgba(0, 0, 0, 0.3),
      0 -6px 16px -6px rgba(0, 0, 0, 0.025);
    animation: shadow-pulse 5s infinite;
  }

  &:after,
  &:before {
    position: absolute;
    content: '';
    border-radius: 50%;
    transition: 0.2s;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    &:before {
      opacity: 0.2;
      transform: scale(1.2);
    }

    &:after {
      animation: none;
    }
  }
  .wistia-video--play-icon {
    display: flex;
    svg {
      width: 23px;
      height: 23px;
      fill: #fff;
      z-index: 1;
      margin-left: ${({ playButton }) => playButton && '5px'};
    }
  }
`;

export { StyledButton };
